"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _g;
var EyeDisabled = function EyeDisabled(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 20 16"
  }, props), _g || (_g = /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
    opacity: ".42"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.066 9.822c.269-.569.434-1.195.434-1.867a4.46 4.46 0 0 0-1.317-3.165A4.51 4.51 0 0 0 10 3.48c-1.041 0-2.05.365-2.849 1.029l2.3 1.768c.028-.102.044-.206.049-.311 0-.316-.103-.623-.291-.877a2.975 2.975 0 0 1 2.622.483 2.938 2.938 0 0 1 1.006 3.306l1.229.944zm5.829 5.11l-.614.785a.5.5 0 0 1-.702.087L.193 1.674A.495.495 0 0 1 .105.978L.72.192A.5.5 0 0 1 1.42.105L5.396 3.16A9.673 9.673 0 0 1 10 1.99c3.841 0 7.196 2.224 8.891 5.512a1 1 0 0 1 0 .907 10.303 10.303 0 0 1-2.539 3.171l3.455 2.655c.218.169.257.481.088.698zm-9.083-2.584l1.622 1.247c-.782.201-1.593.325-2.434.325-3.842 0-7.197-2.224-8.891-5.512a1 1 0 0 1 0-.907c.32-.621.716-1.19 1.147-1.727l3.278 2.519A4.473 4.473 0 0 0 10 12.429a4.53 4.53 0 0 0 .812-.081z"
  })))));
};
var _default = exports.default = EyeDisabled;